import { render } from "./UZSPayInCanceledDealsCountCheckDescription.vue?vue&type=template&id=38fac38d&ts=true"
import script from "./UZSPayInCanceledDealsCountCheckDescription.vue?vue&type=script&lang=ts"
export * from "./UZSPayInCanceledDealsCountCheckDescription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__